// Customer-service pages linked from the footer "Info" column, in footer order.
// `key` points at the copy in locales/info/<lang>.js (info.<key>).
// Shared by StoreLayout (routes), Footer and the prerender script.
export const INFO_PAGES = [
  { path: '/contact', key: 'contact' },
  { path: '/terms', key: 'terms' },
  { path: '/refund-policy', key: 'refund' },
  { path: '/privacy-policy', key: 'privacy' },
  { path: '/cancellation-policy', key: 'cancellation' },
  { path: '/faq', key: 'faq' },
  { path: '/subscriptions', key: 'subscriptions' },
  { path: '/counterfeit', key: 'counterfeit' },
];
